import {useQuery} from "@tanstack/react-query";
import {readOutgoingSerial} from "../../../../api/support/RMA";
import {BasicSearchType} from "../../../../types/common/basic";

type Props = {
    param: BasicSearchType;
};

export const useReadOutgoingSerial = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readOutgoingSerial", param],
        queryFn: async () => await readOutgoingSerial(param),
        select: (res) => res?.data.result ?? null,
    });

    return {data};
};
